import { render, staticRenderFns } from "./ApprovalChangeStatus.vue?vue&type=template&id=00b4c1f6&scoped=true"
import script from "./ApprovalChangeStatus.vue?vue&type=script&lang=js"
export * from "./ApprovalChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./ApprovalChangeStatus.vue?vue&type=style&index=0&id=00b4c1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4c1f6",
  null
  
)

export default component.exports